import { Detect } from "../internal/Detect"

/** `navigator`, or `undefined` where the environment has none (absent in node). */
export const GetNavigator = (): Navigator | undefined => Detect("navigator")
